/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Noorganizations1Inputs */

const en_titles_noorganizations1 = /** @type {(inputs: Titles_Noorganizations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organizations`)
};

/**
* | output |
* | --- |
* | "No organizations" |
*
* @param {Titles_Noorganizations1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_noorganizations1 = /** @type {((inputs?: Titles_Noorganizations1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Noorganizations1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_noorganizations1(inputs)
});
export { titles_noorganizations1 as "titles_noOrganizations" }